
import { defineComponent, ref } from 'vue';

import FormularioUnidade from "./forms/unidades/FormularioUnidade.vue";

import UnidadeTable from "./components/UnidadeTable.vue";

import moment from 'moment';

import fintailapi from "../api";

import { useToast } from "vue-toastification";

export default defineComponent({
  name: "tables",
  components: {
    FormularioUnidade,
    UnidadeTable
  },
  data() {
    return {
      rows: [],
      operacoes:[],
      unidades:{id:"-", data_nascimento:"01/01/1900"},
      current_page: 0,
      offset:0,
      current_offset:0,
      total_count: 0,
      total_pages: 0,
      per_page: 10,
      per_page_options: [10, 30, 50, 100, -1], // -1 = todos
      toast : useToast(),
      local_page : "Unidades de Transporte",
      pesquisando:false,
    };
  },
  methods: {
    getOperacoes(offset:number) {

      fintailapi
      .get(`/operacoes?offset=${offset}&limit=100`)
      .then((response:any) => {
        this.operacoes = response.data.rows
      })
      .catch((error:any) => {

      })

    }, 
    searchCall(campo:any, termo:any) {

      fintailapi
        .get(`/unidades/pesquisar/campo?term=${termo}&field=${campo}`)
        .then((response:any) => {
          this.current_offset = 0;
          this.current_page = 0 /  this.per_page; // Atualiza a página com base no offset
          this.total_count = response.data.count;
          this.total_pages = Math.ceil(response.data.count /  this.per_page);
          this.rows = response.data.rows;
          this.pesquisando = true;
        })
        .catch((error:any) => {
          this.toast.error(`Erro:${ error.response.data.error }, tente novamente.`);
        })

    },
    getUnico(id:any) {

      fintailapi
        .get(`/unidades/${id}`)
        .then((response:any) => {
          this.unidades = response.data
          this.unidades.data_nascimento = moment(this.unidades.data_nascimento , "YYYY-MM-DD").format("DD/MM/YYYY");
        })
        .catch((error:any) => {
            this.toast.error("Erro, tente novamente.");
        })
    },
    salvarUnico(veiculo:any) {

 
      veiculo.data_nascimento = moment(veiculo.data_nascimento, "DD/MM/YYYY").format("YYYY-MM-DD");

      if(veiculo.id != '' && veiculo.id != undefined){

        fintailapi
        .put(`/unidades/${veiculo.id}`, veiculo)
        .then((response:any) => {
          
          this.toast.success("Unidades atualizada com sucesso");
          this.unidades.id = "-"
          this.getPaginas(this.current_offset)

        })
        .catch((error:any) => {
          this.toast.error("Erro ao atualizar Unidade, tente novamente.");
         })

        }else{

            veiculo.id = undefined
            fintailapi
            .post(`/unidades`, veiculo)
            .then((response:any) => {
              
              this.toast.success("Unidades cadastrada com sucesso");

              this.unidades.id = "-"
              this.getPaginas(this.current_offset)

            })
            .catch((error:any) => {
              this.toast.error("Erro ao cadastrar Unidade, tente novamente.");
            })

      }

    },
    salvarEmLote(unidades:any) {

      
      unidades.id = undefined
      fintailapi
      .post(`/unidades/lote`, unidades)
      .then((response:any) => {
        
        this.toast.success("Unidades em Lote cadastradas com sucesso");

        this.unidades.id = "-"
        this.getPaginas(this.current_offset)

      })
      .catch((error:any) => { 
        this.toast.error("Erro ao cadastrar Unidades, tente novamente.");
       })


    },
    deleteUnico(id:any) {
      fintailapi
        .delete(`/unidades/${id}`)
        .then((response:any) => {

          this.toast.success("Unidade excluída com sucesso");
          this.getPaginas(this.current_offset)

        })
        .catch((error:any) => {
          this.toast.error("Erro ao excluir Unidade, tente novamente.");
        })
    },
    fecharUnico() {

        this.unidades.id = "-"

    },
    getPaginas(offset:number) {


      if (this.total_count > 0 && (offset < 0 || offset >= this.total_count)) return; // Impede valores inválidos

        this.current_offset = offset;

        

        fintailapi
        .get(`/unidades?offset=${offset}&limit=${this.per_page}`)
        .then((response:any) => {

          this.current_page = offset / this.per_page; // Atualiza a página com base no offset
          this.total_count = response.data.count;
          this.total_pages = Math.ceil(response.data.count / this.per_page);
          this.rows = response.data.rows;


          this.getOperacoes(0)
        
        })
        .catch((error:any) => {
        })

    },
   },
   created() {
    
      let modo = this.$route.params.id ||'view';

      if(modo=="criar"){
        this.unidades.id = ""
      }

      this.getPaginas(0)


   },

});


